/* eslint-disable no-unused-vars */
export enum PublicRouteUrls {
  LOGIN = '/login'
}

export enum PrivateRouteUrls {
  USERS = '/users',
  USER_PERMISSIONS = '/user-permissions',
  DOMAINS = '/domains',
  DOMAIN_VARS = '/domain-vars',
  DOMAIN_VAR_VALUES = '/domain-var-values',
  CLIENTS = '/clients',
  ROLES = '/roles',
  CREDENTIALS = '/credentials',
  ROLE_CREDENTIALS = '/role-credentials',
  CLIENT_STATUS = '/client-status'
}
